import { Card, Heading, Image, Paragraph } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

export const OverflowWrapHeading = styled(Heading, {
  base: {
    overflowWrap: 'break-word',
    marginBlock: '400',
    textAlign: 'center',
  },
});

export const OverflowWrapParagraph = styled(Paragraph, {
  base: {
    overflowWrap: 'break-word',
    textAlign: 'center',
  },
});

export const SpacedCard = styled(Card, {
  base: {
    padding: '600',
  },
});

export const CardImage = styled(Image, {
  base: {
    display: 'block',
    marginInline: 'auto',
    width: '128px',
    height: '128px',
  },
});
